import { render, staticRenderFns } from "./kop.vue?vue&type=template&id=a18418dc&"
import script from "./kop.vue?vue&type=script&lang=js&"
export * from "./kop.vue?vue&type=script&lang=js&"
import style0 from "./kop.vue?vue&type=style&index=0&id=a18418dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports